import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { Router } from '@angular/router';
import { CheckAuth } from 'src/Services/utility.service';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { TRFAContentGetModel, TRFAContentModel } from 'src/Models/TRFAContentModel';
import { StateMasterService } from 'src/Services/state-master.service';
import { StateMasterModel } from 'src/Models/stateMasterModel';
import { TRFAFundModel } from 'src/Models/TRFAFundModel';
import { TrfaFundMasterService } from 'src/Services/trfa-fund-master.service';
import { TrfaContentMasterService } from 'src/Services/trfa-content-master.service';
import { TRFASourceModel } from 'src/Models/TRFASourceModel';
import { TrfaSourceMasterService } from 'src/Services/trfa-source-master.service';
import { TrfaCategoryMasterService } from 'src/Services/trfa-category-master.service';
import { RouterExtService } from 'src/Services/RouterExtService';
import { DatePipe } from '@angular/common';
import { TrfaCarrierMasterService } from 'src/Services/trfa-carrier--master.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';
import * as DOMPurify from 'dompurify';
import { of, Subject } from 'rxjs';
import { catchError, debounceTime, map, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit, AfterViewInit, OnDestroy {

  stateCode: any;
  tokenKey: string;
  listofContent: TRFAContentGetModel[];
  listofContentExport: TRFAContentGetModel[];
  templistofContent: TRFAContentGetModel[]

  PageNumber: number;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  sesssionOrderBy:string='';
  Note: string;

  auditMonth: any;
  listOfMonth1 = [];

  upDowRuleTextCSS: string = '';
  upDowfundNameCSS: string = '';
  upDowSubcategoryCSS: string = '';
  upDowEffectiveDateCSS: string = '';
  upDowRuleCitationCSS: string = '';
  upDowLastAuditCSS: string = '';
  upDowCategoryCSS: string = '';
  upDowSourceCSS: string = '';
  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  totalRecordCount: number = 0;

  //State List
  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  listOfStateIds = [];
  stateId: string = ' ';
  stateList: StateMasterModel[] = [];

  //Fund
  fundID: string = ' ';
  dropdownListFund = [];
  selectedItemsFund = [];
  dropdownSettingsFund = {};
  listOffundIDs = [];
  fundList: TRFAFundModel[] = [];
  isFundFilterLoading = false;
  private isAllFundsSelected = false;
  private isApplyingFundSelection = false;
  private fundDropdownPatched = false;
  private fundSelectedIdMap: { [id: string]: boolean } = {};
  private readonly fundBadgeLimit = 50;
  private readonly allFundsPlaceholderId = '__ALL_FUNDS__';
  private readonly manyFundsPlaceholderId = '__MANY_FUNDS__';
  private fundLoad$ = new Subject<string>();
  private contentLoad$ = new Subject<void>();
  private destroy$ = new Subject<void>();
  private fundApplySeq = 0;
  private fundSelectionSeq = 0;
  @ViewChild('fundFilterDropdown', { static: false }) fundFilterDropdown: AngularMultiSelect;

  //Source
  SourceList: TRFASourceModel[] = [];
  selectedItemsSource = [];
  dropdownListSource = [];
  dropdownSettingsSource = {};
  listOfsource = [];
  sourceTypeId: string = '';

  categoryListMain: any[] = [];
  dropdownDateCategoryFilterMain: any[] = [];
  dropdownSettingsDateCategoryFilterMain = {};
  selectedItemsCategoryMain = [];
  listOfCategoryIDsMain = [];
  categoryId: string = '';

  module = "TRFA";
  stateIds: string = ' ';
  ContentId: number = 0;
  openMenuIndex: number = -1;
  isRowEdited = false;

  carrierList: any[] = [];
  dropdownDateCarrierFilter: any[] = [];
  dropdownSettingsDateCarrierFilter = {};
  selectedItemsCarrier = [];
  listOfCarrierIDs = [];
  listOfCarrierName = [];

  categoryList: any[] = [];
  dropdownDateCategoryFilter: any[] = [];
  dropdownSettingsDateCategoryFilter = {};
  selectedItemsCategory = [];
  listOfCategoryIDs = [];
  categorysId: string = '';
  listOfCategoryName = [];
  userID: any;
  ckeConfig: any;

  copyOfInternalDocPath: string = "";
  copyOfInternalDocName: string = "";

  constructor(private readonly router: Router,
    private readonly trfaContentMaster: TrfaContentMasterService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private readonly stateService: StateMasterService,
    private readonly trfaFundMaster: TrfaFundMasterService,
    private readonly trfaSourceMaster: TrfaSourceMasterService,
    private readonly categoryMasterService: TrfaCategoryMasterService,
    private readonly routerService: RouterExtService,
    private readonly datePipe: DatePipe,
    private readonly carrierMasterService: TrfaCarrierMasterService,
    private sessionStorageService: SessionStorageService,
    private readonly ngZone: NgZone
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofContent = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'CategorySort';
    this.sesssionOrderBy='CategorySort';
    this.Note = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Contents');
    this.userID = this.sessionStorageService.getAdminUserId();

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.upDowCategoryCSS = 'fa fa-arrow-up';
    this.dropdownSettingsState = {
      singleSelection: false,
      text: "Filter by Jurisdiction",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Jurisdiction(s) available',
      showCheckbox: true
    };
    this.dropdownSettingsFund = {
      singleSelection: false,
      text: "Filter by Fund",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Fund(s) available',
      showCheckbox: true,
      lazyLoading: true,
      enableCheckAll: true,
      enableFilterSelectAll: true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All"
    };

    this.dropdownSettingsDateCarrierFilter = {
      singleSelection: false,
      text: "Select carriers",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No Carrier(s) available',
      showCheckbox: true
    };

    // this.dropdownSettingsSource = {
    //   singleSelection: false,
    //   text: "Filter by Source",
    //   enableSearchFilter: true,
    //   classes: "borderLessTextBoxGreen",
    //   badgeShowLimit: 1,
    //   noDataLabel: 'No Source(s) available',
    //   showCheckbox: true
    // };

    this.dropdownSettingsDateCategoryFilterMain = {
      singleSelection: false,
      text: "Filter by Category",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Category(s) available',
      showCheckbox: true
    };

    this.dropdownSettingsDateCategoryFilter = {
      singleSelection: false,
      text: "Filter by Category",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Category(s) available',
      showCheckbox: true
    };

    this.ckeConfig = {
      versionCheck: false,
      toolbar: [
        {
          items:
            [
              'Undo', 'Redo', 'Link', 'Unlink', 'Anchor',
              'Image', 'Table', 'SpecialChar', 'Maximize', 'Source', 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat',
              'NumberedList', 'BulletedList', 'Outdent', 'Indent', 'Styles', 'Format', 'Font'
            ]
        }],
    }

    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.initPageLoaders();
    this.getState();
    this.getFund();
    this.getCategory();
    this.getCarrier();
    this.PageNumber = 1;
    if (this.routerService.getPreviousUrl().includes('admin/trfa/content/manage') || this.routerService.getPreviousUrl().includes('admin/trfa/content/history')) {
      this.setSaveFilter();
    }
    else {
      //this.clearSession();
      this.OrderBy = 'CategorySort';
      this.setSaveFilter();
      //this.GetContent();
    }
    // this.getSource();    
  }

  ngAfterViewInit() {
    this.patchFundFilterDropdown();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFundFilterOpen() {
    this.patchFundFilterDropdown();
    this.markFundSelectAllChecked();
  }

  private initPageLoaders() {
    this.fundLoad$.pipe(
      debounceTime(50),
      switchMap(stateId => {
        const requestSeq = this.fundApplySeq;
        return this.trfaFundMaster.GetFundV2(this.tokenKey, stateId, true, false).pipe(
          catchError(() => of(null)),
          map(result => ({ result: result, requestSeq: requestSeq }))
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe(payload => this.applyFundFilterData(payload.result, payload.requestSeq));

    this.contentLoad$.pipe(
      switchMap(() => this.trfaContentMaster.GetAllContentV2(this.tokenKey, this.PageNumber, this.PageSize, this.stateId, this.fundID, " ", this.categoryId, "", this.OrderBy, this.auditMonth, false).pipe(
        catchError(error => {
          this.stateCode = error;
          return of(null);
        })
      )),
      takeUntil(this.destroy$)
    ).subscribe(data => this.applyContentData(data));
  }

  getCarrier() {
    this.carrierMasterService.GetCarrierV2(this.tokenKey).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.carrierList = result['carrier'];
          this.dropdownDateCarrierFilter = [];
          this.carrierList.forEach(x => {
            this.dropdownDateCarrierFilter.push({ "id": x.carrierTypeId, "itemName": x.carrierName })
          });
        }
      },
      error => { }
    );
  }

  getCategory() {
    this.categoryMasterService.GetCategoryV2(this.tokenKey).subscribe(
      result => {
        if (result['status'] == 'Success') {

          this.categoryListMain = result['category'];
          this.dropdownDateCategoryFilterMain = [];
          this.categoryListMain.forEach(x => {
            this.dropdownDateCategoryFilterMain.push({ "id": x.categoryID, "itemName": x.categoryName })
          });

          this.dropdownDateCategoryFilter = [];
          this.categoryListMain.forEach(x => {
            this.dropdownDateCategoryFilter.push({ "id": x.categoryID, "itemName": x.categoryName })
          });


          if (this.listOfCategoryIDsMain != null && this.listOfCategoryIDsMain != undefined) {
            for (let iCounter = 0; iCounter < this.listOfCategoryIDsMain.length; iCounter++) {
              if (this.listOfCategoryIDsMain[iCounter] != '') {
                let obj = result["category"].filter(m => m.categoryID == this.listOfCategoryIDsMain[iCounter]);
                if (obj != null) {
                  this.selectedItemsCategoryMain.push({ "id": obj[0].categoryID, "itemName": obj[0].categoryName });
                }
              }
            }
          }

        }
      },
      error => { }
    );
  }

  getFund() {
    this.fundApplySeq++;
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.isFundFilterLoading = true;
    this.dropdownSettingsFund['noDataLabel'] = 'Loading funds...';
    this.fundLoad$.next(String(this.stateId));
  }

  private applyFundFilterData(result: any, requestSeq: number) {
    if (requestSeq !== this.fundApplySeq) {
      return;
    }
    const fundList = result && result['fund'] ? result['fund'] : [];
    const selectedFundIds = this.listOffundIDs || [];

    this.ngZone.runOutsideAngular(() => {
      const selectedIdSet = {};
      for (let i = 0; i < selectedFundIds.length; i++) {
        selectedIdSet[selectedFundIds[i]] = true;
      }

      const dropdownItems = new Array(fundList.length);
      const selectedItems = [];
      const keptIds = [];
      const selectedIdMap = {};
      for (let i = 0; i < fundList.length; i++) {
        const fund = fundList[i];
        const fundId = fund.fundID != null ? fund.fundID : fund.id;
        const fundName = fund.fundName || fund.itemName || '';
        const item = {
          id: fundId,
          fundID: fundId,
          itemName: fundName,
          fundName: fundName,
          shortName: fund.shortName || '',
          fundTypeName: fund.fundTypeName || ''
        };
        dropdownItems[i] = item;
        if (selectedIdSet[fundId]) {
          selectedItems.push(item);
          keptIds.push(fundId);
          selectedIdMap[fundId] = true;
        }
      }

      setTimeout(() => {
        this.ngZone.run(() => {
          if (requestSeq !== this.fundApplySeq) {
            return;
          }
          this.fundList = fundList;
          this.dropdownListFund = dropdownItems;
          this.listOffundIDs = keptIds;
          this.fundSelectedIdMap = selectedIdMap;
          this.isAllFundsSelected = dropdownItems.length > 0 && keptIds.length === dropdownItems.length;
          this.isFundFilterLoading = false;
          this.dropdownSettingsFund['noDataLabel'] = 'No Fund(s) available';
          this.setSelectedFundDisplay(selectedItems);
        });
      }, 0);
    });
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetContent();
  }

  GetContent() {
    this.isloading = true;
    this.listofContent = [];
    this.fundID = ' ';
    const fundFilterValue = this.getFundFilterValue();
    if (fundFilterValue) {
      this.fundID = fundFilterValue;
    }
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }

    this.categoryId = ' ';
    if (this.listOfCategoryIDsMain.length > 0) {
      this.categoryId = this.listOfCategoryIDsMain.join(',')
    }

    this.auditMonth = '';
    if (this.listOfMonth1.length > 0) {
      this.auditMonth = this.listOfMonth1.join(',')
    }

    if (this.Note == "null") this.Note = " ";
    this.contentLoad$.next();
  }

  private applyContentData(data: any) {
    this.isloading = false;
    if (!data) {
      this.listofContent = [];
      this.totalRecordCount = 0;
      this.isRecord = true;
      return;
    }
    const rows = data['content'];
    if (rows != null) {
      for (let i = 0; i < rows.length; i++) {
        rows[i].isEdit = false;
        rows[i].carrierHtml = this.replaceCommaLine(rows[i].carrierName);
      }
      this.listofContent = rows;
      if (rows.length == 0) {
        this.totalRecordCount = 0;
        this.isRecord = true;
      }
      else {
        this.isRecord = false;
        this.totalRecordCount = rows[0].totalRecordCount;
      }
    }
    else {
      this.listofContent = [];
      this.totalRecordCount = 0;
      this.isRecord = true;
    }
  }

  trackByContent(index: number, item: TRFAContentGetModel) {
    return item && item.contentID ? item.contentID : index;
  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.Note = $event.target.value;
    else
      this.Note = 'null';
    this.resetPageNoandSize();
    this.GetContent();
  }

  sort(sortBy: string) {
    this.upDowRuleTextCSS = '';
    this.upDowfundNameCSS = '';
    this.upDowSubcategoryCSS = '';
    this.upDowSourceCSS = '';
    this.upDowCategoryCSS = '';
    this.upDowEffectiveDateCSS = '';
    this.upDowLastAuditCSS = '';
    this.upDowRuleCitationCSS = '';

    this.sesssionOrderBy=sortBy;
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';
      if (sortBy === "RuleText") {
        this.upDowRuleTextCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "FundID") {
        this.upDowfundNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "RuleCitation") {
        this.upDowRuleCitationCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Subcategory") {
        this.upDowSubcategoryCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "EffectiveDate") {
        this.upDowEffectiveDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "lastAudit") {
        this.upDowLastAuditCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CategorySort") {
        this.upDowCategoryCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "SourceName") {
        this.upDowSourceCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "RuleText") {
        this.upDowRuleTextCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "FundID") {
        this.upDowfundNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "RuleCitation") {
        this.upDowRuleCitationCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Subcategory") {
        this.upDowSubcategoryCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "EffectiveDate") {
        this.upDowEffectiveDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "lastAudit") {
        this.upDowLastAuditCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CategorySort") {
        this.upDowCategoryCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "SourceName") {
        this.upDowSourceCSS = 'fa fa-arrow-up';
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  addContent() {
    let navigation = '/admin/trfa/content/manage';
    this.router.navigate([navigation]);
  }

  ContentContent(ContentId) {
    this.saveSession();
    window.open('/#/admin/trfa/content/manage/' + ContentId, "_blank");
  }


  GetContentById(Content) {

    this.listofContent.forEach(element => {
      element['isEdit'] = false;
    });

    this.templistofContent = JSON.parse(JSON.stringify(this.listofContent));
    Content.isEdit = true;
    Content.effectiveDate = new Date(Content.effectiveDate);
    if (Content.lastAudit != null) {
      Content.lastAudit = new Date(Content.lastAudit);
    }

    this.isRowEdited = true;
    this.trfaContentMaster.GetContentById(this.tokenKey, parseInt(Content.contentID.toString())).subscribe(
      result => {
        if (result['status'] == 'Success') {
          if (this.carrierList.length > 0) {
            this.selectedItemsCarrier = []
            this.listOfCarrierIDs = [];
            this.listOfCarrierName = [];
            for (let iCounter = 0; iCounter < result['content'].carrierTypeID.length; iCounter++) {
              let data = this.carrierList.filter(x => x.carrierTypeId == result['content'].carrierTypeID[iCounter].carrierTypeId)[0];
              this.selectedItemsCarrier.push({ "id": data.carrierTypeId, "itemName": data.carrierName })
              this.listOfCarrierIDs.push(data.carrierTypeId)
              this.listOfCarrierName.push(data.carrierName)
            }
          }

          if (this.categoryListMain.length > 0) {
            this.selectedItemsCategory = [];
            this.listOfCategoryIDs = [];
            this.listOfCategoryName = [];
            result['content'].categoryID.map((x) => {
              let data = this.categoryListMain.filter(y => y.categoryID == x.categoryID)[0];
              this.selectedItemsCategory.push({ "id": data.categoryID, "itemName": data.categoryName })
              this.listOfCategoryIDs.push(data.categoryID)
              this.listOfCategoryName.push(data.categoryName);
            })
          }

          this.copyOfInternalDocPath = result['content'].copyOfInternalDocPath;
          this.copyOfInternalDocName = result['content'].copyOfInternalDocName;
        }
      });
  }

  setDeleteData(id) {
    this.ContentId = id;
  }

  deleteContent(ContentId) {
    this.isloading = true;
    this.trfaContentMaster.DeleteContent(this.tokenKey, ContentId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          // if (data['message'] != "")
          //   this.showMessage(data['message'], 'Warning', 'warning')
          // else
          this.showMessage("Content Deleted successfully", 'Success', 'success')
        }
        this.resetPageNoandSize();
        this.GetContent();
      },
      error => { this.stateCode = error }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelectState($event) {
    this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
    this.listOfStateIds.push($event.id);
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectState($event) {
    if (this.listOfStateIds != null) {
      if (this.listOfStateIds.length > 0) {
        this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectAll($event) {
    this.listOfStateIds = this.getIdsFromItems($event);
    this.stateId = this.listOfStateIds.join(',');
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectAllState($event) {
    this.listOfStateIds = [];
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }


  onSelectFund($event) {
    if (this.isApplyingFundSelection || this.isPlaceholderFundItem($event)) {
      return;
    }
    const fundId = $event.id != null ? $event.id : $event.fundID;
    this.isAllFundsSelected = false;
    this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, fundId)
    this.listOffundIDs.push(fundId);
    this.fundSelectedIdMap[fundId] = true;
    this.selectedItemsFund = this.appendSelectedFundItem($event);
    this.compactSelectedFundIfNeeded();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectFund($event) {
    if (this.isApplyingFundSelection || this.isPlaceholderFundItem($event)) {
      this.clearCompactFundSelection();
      return;
    }
    const fundId = $event.id != null ? $event.id : $event.fundID;
    this.isAllFundsSelected = false;
    if (this.listOffundIDs != null) {
      if (this.listOffundIDs.length > 0) {
        this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, fundId)
      }
    }
    delete this.fundSelectedIdMap[fundId];
    this.selectedItemsFund = (this.selectedItemsFund || []).filter(item => item && item.id !== fundId);
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectAllFund($event) {
    this.applyAllFundsSelection();
  }

  onDeSelectAllFund($event) {
    this.clearCompactFundSelection();
  }

  replaceCommaLine(data) {
    if (!data) {
      return '';
    }
    return String(data).split(",").join("<br />");
  }
  getState() {
    this.stateService.GetStateMaster(this.tokenKey, this.module).subscribe(
      data => {
        this.stateList = data['state'];
        this.dropdownListState = [];
        if (this.stateList.length > 0) {
          this.stateList.forEach(x => {
            this.dropdownListState.push({ "id": x.stateId, "itemName": x.name })
          });
        }

        if (this.listOfStateIds != null && this.listOfStateIds != undefined) {
          for (let iCounter = 0; iCounter < this.listOfStateIds.length; iCounter++) {
            if (this.listOfStateIds[iCounter] != '') {
              let obj = data["state"].filter(m => m.stateId == this.listOfStateIds[iCounter]);
              if (obj != null) {
                this.selectedItemsState.push({ "id": obj[0].stateId, "itemName": obj[0].name });
              }
            }
          }
        }

      },
      error => { }
    );
  }

  getSource() {
    this.trfaSourceMaster.GetSource(this.tokenKey).subscribe(
      data => {
        this.SourceList = data['source'];
        this.dropdownListSource = [];
        if (this.SourceList.length > 0) {
          this.SourceList.forEach(x => {
            this.dropdownListSource.push({ "id": x.sourceTypeId, "itemName": x.sourceName })
          });
        }
      },
      error => { }
    );
  }

  onSelectSource($event) {
    this.listOfsource = this.removeElemetninArray(this.listOfsource, $event.id)
    this.listOfsource.push($event.id);
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectSource($event) {
    if (this.listOfsource != null) {
      if (this.listOfsource.length > 0) {
        this.listOfsource = this.removeElemetninArray(this.listOfsource, $event.id)
      }
    }
    if (this.listOfsource.length > 0) {
      this.sourceTypeId = this.listOfsource.join(',')
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectAllSource($event) {
    this.listOfsource = [];
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectAllSource($event) {
    for (const item of $event) {
      if (this.listOfsource != null) {
        if (this.listOfsource.length > 0) {
          this.listOfsource = this.removeElemetninArray(this.listOfsource, item.id)
          this.listOfsource.push(item.id);
        }
        else {
          this.listOfsource.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectCategoryMain($event) {
    this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, $event.id)
    this.listOfCategoryIDsMain.push($event.id);
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectCategoryMain($event) {
    if (this.listOfCategoryIDsMain != null) {
      if (this.listOfCategoryIDsMain.length > 0) {
        this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, $event.id)
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectAllCategoryMain($event) {
    this.listOfCategoryIDsMain = this.getIdsFromItems($event);
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectAllCategoryMain($event) {

    this.listOfCategoryIDsMain = [];
    this.resetPageNoandSize();
    this.GetContent();
  }

  resetPageNoandSize() {
    this.PageNumber = 1;
    this.PageSize = 10;
  }

  clear() {
    this.stateId = '';
    this.fundID = '';
    this.categoryId = '';

    this.selectedItemsState = [];
    this.selectedItemsFund = [];
    this.selectedItemsCategoryMain = [];

    this.listOfStateIds = [];
    this.listOffundIDs = [];
    this.listOfCategoryIDsMain = [];
    this.isAllFundsSelected = false;
    this.fundSelectedIdMap = {};

    this.GetContent();
    this.getFund();
  }

  saveSession() {
    sessionStorage.setItem('ContentSaveFilterPageNo', this.PageNumber.toString());
    sessionStorage.setItem('ContentSaveFilterOrderBy', this.sesssionOrderBy);
    sessionStorage.setItem('ContentSaveFilterIsAscending', this.isAscending ?  'false' : 'true');
    // var ContentSaveFilterFundId='';
    // if (this.listOffundIDs.length > 0) {
    //   ContentSaveFilterFundId=this.listOffundIDs.join(',');
    // }
    sessionStorage.setItem('ContentSaveFilterFundId', JSON.stringify(this.listOffundIDs));
    // var ContentSaveFilterStateId='';
    // if (this.listOfStateIds.length > 0) {
    //   ContentSaveFilterStateId=this.listOfStateIds.join(',');
    // }
    sessionStorage.setItem('ContentSaveFilterStateId', JSON.stringify(this.listOfStateIds));

    // var ContentSaveFilterCategoryId='';
    // if (this.listOfCategoryIDsMain.length > 0) {
    //   ContentSaveFilterCategoryId=this.listOfCategoryIDsMain.join(',');
    // }
    sessionStorage.setItem('ContentSaveFilterCategoryId', JSON.stringify(this.listOfCategoryIDsMain));
  }

  clearSession() {
    sessionStorage.removeItem('ContentSaveFilterPageNo');
    sessionStorage.removeItem('ContentSaveFilterOrderBy');
    sessionStorage.removeItem('ContentSaveFilterIsAscending');
    sessionStorage.removeItem('ContentSaveFilterFundId');
    sessionStorage.removeItem('ContentSaveFilterStateId');
    sessionStorage.removeItem('ContentSaveFilterCategoryId');
  }

  setSaveFilter() {
    if (sessionStorage.getItem('ContentSaveFilterPageNo') != null && sessionStorage.getItem('ContentSaveFilterPageNo') != '' && sessionStorage.getItem('ContentSaveFilterPageNo') != 'undefined') {
      this.PageNumber = parseInt(sessionStorage.getItem('ContentSaveFilterPageNo'));
    }
    if (sessionStorage.getItem('ContentSaveFilterOrderBy') != null && sessionStorage.getItem('ContentSaveFilterOrderBy') != '' && sessionStorage.getItem('ContentSaveFilterOrderBy') != 'undefined') {
      this.OrderBy = sessionStorage.getItem('ContentSaveFilterOrderBy');
    }
    if (sessionStorage.getItem('ContentSaveFilterIsAscending') != null && sessionStorage.getItem('ContentSaveFilterIsAscending') != '' && sessionStorage.getItem('ContentSaveFilterIsAscending') != 'undefined') {
      this.isAscending = sessionStorage.getItem('ContentSaveFilterIsAscending') == 'false' ? false : true;
      this.ContentSessionSort(this.OrderBy);
    }
    if (sessionStorage.getItem('ContentSaveFilterFundId') != null && sessionStorage.getItem('ContentSaveFilterFundId') != '' && sessionStorage.getItem('ContentSaveFilterFundId') != 'undefined') {
      this.listOffundIDs = JSON.parse(sessionStorage.getItem('ContentSaveFilterFundId'));
    }
    if (sessionStorage.getItem('ContentSaveFilterStateId') != null && sessionStorage.getItem('ContentSaveFilterStateId') != '' && sessionStorage.getItem('ContentSaveFilterStateId') != 'undefined') {
      this.listOfStateIds = JSON.parse(sessionStorage.getItem('ContentSaveFilterStateId'));
    }
    if (sessionStorage.getItem('ContentSaveFilterCategoryId') != null && sessionStorage.getItem('ContentSaveFilterCategoryId') != '' && sessionStorage.getItem('ContentSaveFilterCategoryId') != 'undefined') {
      this.listOfCategoryIDsMain = JSON.parse(sessionStorage.getItem('ContentSaveFilterCategoryId'));
    }
    this.GetContent();
    this.clearSession();
  }

  ContentSessionSort(sortBy: string) {
    this.upDowRuleTextCSS = '';
    this.upDowfundNameCSS = '';
    this.upDowSubcategoryCSS = '';
    this.upDowSourceCSS = '';
    this.upDowCategoryCSS = '';
    this.upDowEffectiveDateCSS = '';
    this.upDowLastAuditCSS = '';
    this.upDowRuleCitationCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      
      this.OrderBy = sortBy + ' DESC';
      if (sortBy === "RuleText") {
        this.upDowRuleTextCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "FundID") {
        this.upDowfundNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "RuleCitation") {
        this.upDowRuleCitationCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Subcategory") {
        this.upDowSubcategoryCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "EffectiveDate") {
        this.upDowEffectiveDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "lastAudit") {
        this.upDowLastAuditCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CategorySort") {
        this.upDowCategoryCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "SourceName") {
        this.upDowSourceCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "RuleText") {
        this.upDowRuleTextCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "FundID") {
        this.upDowfundNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "RuleCitation") {
        this.upDowRuleCitationCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Subcategory") {
        this.upDowSubcategoryCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "EffectiveDate") {
        this.upDowEffectiveDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "lastAudit") {
        this.upDowLastAuditCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CategorySort") {
        this.upDowCategoryCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "SourceName") {
        this.upDowSourceCSS = 'fa fa-arrow-up';
      }
    }
  }

  PreviousContentData(ContentId) {
    this.saveSession();
    let navigation = '/admin/trfa/content/history/' + ContentId;
    this.router.navigate([navigation]);
  }

  onFilterSelectAllState($event) {
    this.listOfStateIds = this.addIdsFromItems(this.listOfStateIds, $event);
    this.stateId = this.listOfStateIds.join(',');
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterDeSelectAllState($event) {
    this.listOfStateIds = this.removeIdsFromItems(this.listOfStateIds, $event);
    this.stateId = this.listOfStateIds.join(',');
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterSelectAllFund($event) {
    const items = $event || [];
    if (this.dropdownListFund && this.dropdownListFund.length > 0 && items.length === this.dropdownListFund.length) {
      this.applyAllFundsSelection();
      return;
    }
    this.isAllFundsSelected = false;
    this.listOffundIDs = this.addIdsFromItems(this.listOffundIDs, items);
    this.fundSelectedIdMap = {};
    for (let i = 0; i < this.listOffundIDs.length; i++) {
      this.fundSelectedIdMap[this.listOffundIDs[i]] = true;
    }
    if (this.listOffundIDs.length > this.fundBadgeLimit) {
      this.selectedItemsFund = [this.buildFundCountPlaceholder(this.listOffundIDs.length)];
      this.syncFundDropdownSelection(this.selectedItemsFund, false);
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterDeSelectAllFund($event) {
    this.isAllFundsSelected = false;
    this.listOffundIDs = this.removeIdsFromItems(this.listOffundIDs, $event);
    if ($event) {
      for (let i = 0; i < $event.length; i++) {
        const fundId = $event[i].id != null ? $event[i].id : $event[i].fundID;
        delete this.fundSelectedIdMap[fundId];
      }
    }
    this.resetPageNoandSize();
    if (this.listOffundIDs.length == 0) {
      this.fundSelectedIdMap = {};
      this.selectedItemsFund = [];
      this.syncFundDropdownSelection([]);
    }
    else if (this.listOffundIDs.length > this.fundBadgeLimit) {
      this.selectedItemsFund = [this.buildFundCountPlaceholder(this.listOffundIDs.length)];
      this.syncFundDropdownSelection(this.selectedItemsFund, false);
    }
    this.GetContent();
  }

  onFilterSelectAllCategory($event) {
    this.listOfCategoryIDsMain = this.getIdsFromItems($event);
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterDeSelectAllCategory($event) {
    this.listOfCategoryIDsMain = [];
    this.resetPageNoandSize();
    this.GetContent();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.openMenuIndex === -1 || this.openMenuIndex == null) {
      return;
    }
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = -1;
    }
  }

  cancelEdit(data) {
    data.isEdit = false;
    this.isRowEdited = false;
    this.selectedItemsCarrier = [];
    this.selectedItemsCategory = [];
    this.selectedItemsCategoryMain = [];
    this.selectedItemsSource = [];
    this.selectedItemsFund = [];
    this.selectedItemsState = [];
    this.isAllFundsSelected = false;
    this.fundSelectedIdMap = {};

    this.listofContent = this.templistofContent;
  }

  saveContent(item) {
    this.saveSession();
    let userId = this.userID;
    let carrierId = this.listOfCarrierIDs.join(',');
    let carrierName = this.listOfCarrierName.join(',');
    let categoryId = this.listOfCategoryIDs.join(',');
    let CategoryName = this.listOfCategoryName.join(',');
    // let editlistOffundID = this.EditlistOffundIDs.join(',');
    // let fundName = this.EditlistOfFundName.join(',');
    // let sourceID = this.EditlistOfsource.join(',');
    // let sourceName = this.EditlistOfsourceName.join(',');
    // let MonthList = this.listOfMonth.join(',');


    if (carrierId == "") {
      this.showMessage("Please select carrier", 'warning', 'error');
      return;
    }
    if (categoryId == "") {
      this.showMessage("Please select category", 'warning', 'error');
      return;
    }
    if (item.ruleText == "") {
      this.showMessage("Please Enter ruleText", 'warning', 'error');
      return;
    }
    if (item.effectiveDate == "") {
      this.showMessage("Please select effectivedate", 'warning', 'error');
      return;
    }
    // if (editlistOffundID == "") {
    //   this.showMessage("Please select fund", 'warning', 'warning');
    // }


    if (item.internalNote == null) {
      item.internalNote = "";
    }
    if (item.ruleCitation == null) {
      item.ruleCitation = "";
    }
    if (item.subcategory == null) {
      item.subcategory = "";
    }

    let value = {
      contentID: item.contentID,
      // fundID: editlistOffundID,
      effectiveDate: this.datePipe.transform(item.effectiveDate, 'yyyy-MM-dd hh:mm:ss'),
      ruleText: item.ruleText.trim(),
      ruleCitation: item.ruleCitation == "" ? item.ruleCitation : item.ruleCitation.trim(),
      internalNote: item.internalNote == "" ? item.internalNote : item.internalNote.trim(),
      subcategory: item.subcategory == "" ? item.subcategory : item.subcategory.trim(),
      carrierTypeID: carrierId,
      categoryID: categoryId,
      lastAudit: this.datePipe.transform(item.lastAudit, 'yyyy-MM-dd hh:mm:ss'),
      // auditMonth: MonthList == '' ? null : MonthList,
      // sourceTypeId: sourceID == "" ? "" : sourceID,
      userId: userId,
      carrierTypeName: carrierName,
      CategoryTypeName: CategoryName
      // sourceTypeName: sourceName == '' ? null : sourceName,
      // fundName: fundName
    }

    let formData = new FormData();
    formData.append('contentID', item.contentID);
    formData.append('fundID', item.fundID);
    formData.append('effectiveDate', this.datePipe.transform(item.effectiveDate, 'yyyy-MM-dd hh:mm:ss'));
    formData.append('ruleText', item.ruleText == null ? null : item.ruleText.trim());
    formData.append('ruleCitation', item.ruleCitation == "" ? item.ruleCitation : item.ruleCitation.trim());
    formData.append('internalNote', item.internalNote == "" ? item.internalNote : item.internalNote.trim(),);
    formData.append('subcategory', item.subcategory == "" ? item.subcategory : item.subcategory.trim());
    formData.append('carrierTypeID', carrierId);
    formData.append('categoryID', categoryId);
    formData.append('lastAudit', this.datePipe.transform(item.lastAudit, 'yyyy-MM-dd hh:mm:ss'));
    // formData.append('auditMonth', MonthList);
    // formData.append('sourceTypeId', sourceID == "" ? "" : sourceID);
    formData.append('copyOfInternalDocPath', this.copyOfInternalDocPath);
    formData.append('copyOfInternalDocName', this.copyOfInternalDocName);


    this.trfaContentMaster.ContentAddUpdate(this.tokenKey, formData).subscribe(
      result => {
        if (result['status'] == 'Success') {
          if (result['message'] != "") {
            this.showMessage(result['message'], 'Warning', 'warning')
          } else {
            if (item.contentID > 0) {
              this.showMessage('Content Update successfully', 'Success', 'success');
              //this.resetPageNoandSize();
              this.GetContent();
            }
            else
              this.showMessage('Content saved successfully', 'Success', 'success');
            this.router.navigate(['/admin/trfa/content']);
          }
        }
        else {
          this.showMessage(result['status'], 'Error', 'error');
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
    item.isEdit = false;
    this.isRowEdited = false;
  }

  onSelectCarrier($event) {
    this.listOfCarrierIDs = this.removeElemetninArray(this.listOfCarrierIDs, $event.id)
    this.listOfCarrierName = this.removeElemetninArray(this.listOfCarrierName, $event.itemName)
    this.listOfCarrierIDs.push($event.id);
    this.listOfCarrierName.push($event.itemName);
  }

  onDeSelectCarrier($event) {
    if (this.listOfCarrierIDs != null) {
      if (this.listOfCarrierIDs.length > 0) {
        this.listOfCarrierIDs = this.removeElemetninArray(this.listOfCarrierIDs, $event.id)
      }
    }

    if (this.listOfCarrierName != null) {
      if (this.listOfCarrierName.length > 0) {
        this.listOfCarrierName = this.removeElemetninArray(this.listOfCarrierName, $event.itemName)
      }
    }
  }

  onSelectAllCarrier($event) {
    for (const item of $event) {
      if (this.listOfCarrierIDs != null) {
        if (this.listOfCarrierIDs.length > 0) {
          this.listOfCarrierIDs = this.removeElemetninArray(this.listOfCarrierIDs, item.id)
          this.listOfCarrierIDs.push(item.id);
        }
        else {
          this.listOfCarrierIDs.push(item.id);
        }
      }

      if (this.listOfCarrierName != null) {
        if (this.listOfCarrierName.length > 0) {
          this.listOfCarrierName = this.removeElemetninArray(this.listOfCarrierName, item.itemName)
          this.listOfCarrierName.push(item.itemName);
        }
        else {
          this.listOfCarrierName.push(item.itemName);
        }
      }
    }
  }

  onDeSelectAllCarrier($event) {
    this.listOfCarrierIDs = [];
    this.listOfCarrierName = [];
  }

  onSelectCategory($event) {
    // this.listOfCategoryIDs=[]
    this.listOfCategoryIDs = this.removeElemetninArray(this.listOfCategoryIDs, $event.id)
    this.listOfCategoryIDs.push($event.id);
    // this.GetContent();
  }

  onDeSelectCategory($event) {
    if (this.listOfCategoryIDs != null) {
      if (this.listOfCategoryIDs.length > 0) {
        this.listOfCategoryIDs = this.removeElemetninArray(this.listOfCategoryIDs, $event.id)
      }
    }
    // this.GetContent();
  }

  onSelectAllCategory($event) {
    for (const item of $event) {
      if (this.listOfCategoryIDs != null) {
        if (this.listOfCategoryIDs.length > 0) {
          this.listOfCategoryIDs = this.removeElemetninArray(this.listOfCategoryIDs, item.id)
          this.listOfCategoryIDs.push(item.id);
        }
        else {
          this.listOfCategoryIDs.push(item.id);
        }
      }
    }
    // this.GetContent();
  }

  onDeSelectAllCategory($event) {
    this.listOfCategoryIDs = [];
    // this.GetContent();
  }

  ExportTRFAContents() {
    this.isloading = true;
    this.fundID = ' ';
    const fundFilterValue = this.getFundFilterValue();
    if (fundFilterValue) {
      this.fundID = fundFilterValue;
    }
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }

    this.categoryId = ' ';
    if (this.listOfCategoryIDsMain.length > 0) {
      this.categoryId = this.listOfCategoryIDsMain.join(',')
    }

    this.auditMonth = '';
    if (this.listOfMonth1.length > 0) {
      this.auditMonth = this.listOfMonth1.join(',')
    }

    if (this.Note == "null") this.Note = " ";
    this.trfaContentMaster.GetAllContentV2(this.tokenKey, this.PageNumber, this.PageSize, this.stateId, this.fundID, " ", this.categoryId, "", this.OrderBy, this.auditMonth, true).subscribe(
      data => {
        const rows = data && data['content'] ? data['content'] : [];
        if (rows.length > 0) {
          this.ngZone.runOutsideAngular(() => {
            const tableHtml = this.buildExportHtml(rows);
            this.ngZone.run(() => {
              this.saveExportFile(tableHtml);
              this.isloading = false;
            });
          });
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  private buildExportHtml(rows: any[]): string {
    let html = '<table><thead><tr>';
    const headers = ['Carrier', 'Category', 'Rule Citation', 'Subcategory', 'Rule Text', 'Effective Date', 'Audit Date'];
    for (let i = 0; i < headers.length; i++) {
      html += '<th style="text-align: left;">' + headers[i] + '</th>';
    }
    html += '</tr></thead><tbody>';
    for (let i = 0; i < rows.length; i++) {
      const item = rows[i];
      const auditDate = item.lastAudit == 'null' ? '' : this.formatExportDate(item.lastAudit);
      html += '<tr>';
      html += '<td>' + this.escapeHtml(item.carrierName) + '</td>';
      html += '<td>' + this.escapeHtml(item.categoryName) + '</td>';
      html += '<td>' + this.escapeHtml(item.ruleCitation) + '</td>';
      html += '<td>' + this.escapeHtml(item.subcategory) + '</td>';
      html += '<td>' + this.sanitizeRuleText(item.ruleText) + '</td>';
      html += '<td>' + this.escapeHtml(this.formatExportDate(item.effectiveDate)) + '</td>';
      html += '<td>' + this.escapeHtml(auditDate) + '</td>';
      html += '</tr>';
    }
    html += '</tbody></table>';
    return html;
  }

  private saveExportFile(tableHtml: string) {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableHtml;
    html += "</td></tr></table>";
    let name = 'ExportTRFAContents';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportTRFAContents.xls");
  }

  private formatExportDate(value: any): string {
    if (value == null || value === '' || value === 'null') {
      return '';
    }
    const formatted = this.datePipe.transform(value, 'MMMM dd, yyyy');
    return formatted || '';
  }

  private escapeHtml(value: any): string {
    if (value == null || value === 'null') {
      return '';
    }
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  private sanitizeRuleText(value: any): string {
    if (value == null || value === 'null') {
      return '';
    }
    return DOMPurify.sanitize(String(value));
  }

  private getFundFilterValue(): string {
    if (!this.listOffundIDs || this.listOffundIDs.length == 0) {
      return '';
    }
    return this.listOffundIDs.join(',');
  }

  private patchFundFilterDropdown() {
    const dropdown: any = this.fundFilterDropdown;
    if (!dropdown || dropdown.__fundFilterPatched) {
      this.fundDropdownPatched = !!dropdown;
      return;
    }

    const self = this;
    const originalIsSelected = dropdown.isSelected.bind(dropdown);
    const originalOnItemClick = dropdown.onItemClick.bind(dropdown);
    const originalNgDoCheck = dropdown.ngDoCheck ? dropdown.ngDoCheck.bind(dropdown) : null;

    dropdown.isSelected = function (item) {
      if (self.isAllFundsSelected) {
        return true;
      }
      const fundId = item ? (item.id != null ? item.id : item.fundID) : null;
      if (fundId != null && self.fundSelectedIdMap[fundId]) {
        return true;
      }
      return originalIsSelected(item);
    };

    dropdown.ngDoCheck = function () {
      if (self.isAllFundsSelected && this.data && this.data.length > 0) {
        this.isSelectAll = true;
        return;
      }
      if (originalNgDoCheck) {
        originalNgDoCheck();
      }
    };

    dropdown.toggleSelectAll = function () {
      if (!this.isSelectAll && !self.isAllFundsSelected) {
        self.applyAllFundsSelection();
      } else {
        self.clearCompactFundSelection();
      }
    };

    dropdown.toggleInfiniteFilterSelectAll = function () {
      const items = this.virtualdata || [];
      if (!this.isInfiniteFilterSelectAll) {
        if (items.length > self.fundBadgeLimit) {
          self.onFilterSelectAllFund(items);
          this.isInfiniteFilterSelectAll = true;
          return;
        }
        for (let i = 0; i < items.length; i++) {
          if (!this.isSelected(items[i])) {
            this.addSelected(items[i]);
          }
        }
        this.isInfiniteFilterSelectAll = true;
        self.onFilterSelectAllFund(items);
        return;
      }

      if (self.isAllFundsSelected || self.isPlaceholderFundSelection(self.selectedItemsFund)) {
        self.clearCompactFundSelection();
        this.isInfiniteFilterSelectAll = false;
        return;
      }
      for (let i = 0; i < items.length; i++) {
        if (this.isSelected(items[i])) {
          this.removeSelected(items[i]);
        }
      }
      this.isInfiniteFilterSelectAll = false;
      self.onFilterDeSelectAllFund(items);
    };

    dropdown.onItemClick = function (item, index, event) {
      if (self.isAllFundsSelected) {
        if (event) {
          event.stopPropagation();
        }
        return;
      }
      if (self.isPlaceholderFundSelection(self.selectedItemsFund)) {
        self.toggleCompactFundSelection(item);
        if (event) {
          event.stopPropagation();
        }
        return;
      }
      return originalOnItemClick(item, index, event);
    };

    dropdown.__fundFilterPatched = true;
    this.fundDropdownPatched = true;
  }

  private applyAllFundsSelection() {
    const funds = this.dropdownListFund || [];
    const seq = ++this.fundSelectionSeq;
    this.isApplyingFundSelection = true;
    this.isAllFundsSelected = funds.length > 0;
    this.isFundFilterLoading = false;
    this.selectedItemsFund = funds.length > 0 ? [this.buildAllFundsPlaceholder(funds.length)] : [];
    this.syncFundDropdownSelection(this.selectedItemsFund, true);
    this.markFundSelectAllChecked();

    this.ngZone.runOutsideAngular(() => {
      const ids = new Array(funds.length);
      const selectedIdMap = {};
      for (let i = 0; i < funds.length; i++) {
        ids[i] = funds[i].id;
        selectedIdMap[funds[i].id] = true;
      }
      this.ngZone.run(() => {
        if (seq !== this.fundSelectionSeq) {
          this.isApplyingFundSelection = false;
          return;
        }
        this.listOffundIDs = ids;
        this.fundSelectedIdMap = selectedIdMap;
        this.resetPageNoandSize();
        this.GetContent();
        setTimeout(() => {
          this.markFundSelectAllChecked();
          this.isApplyingFundSelection = false;
        }, 0);
      });
    });
  }

  private clearCompactFundSelection() {
    this.fundSelectionSeq++;
    this.isApplyingFundSelection = true;
    this.isAllFundsSelected = false;
    this.fundSelectedIdMap = {};
    this.listOffundIDs = [];
    this.selectedItemsFund = [];
    this.resetPageNoandSize();
    this.syncFundDropdownSelection([]);
    this.GetContent();
    setTimeout(() => {
      this.isApplyingFundSelection = false;
    }, 0);
  }

  private toggleCompactFundSelection(item: any) {
    if (!item || this.isPlaceholderFundItem(item)) {
      return;
    }
    const fundId = item.id != null ? item.id : item.fundID;
    if (this.fundSelectedIdMap[fundId]) {
      delete this.fundSelectedIdMap[fundId];
      this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, fundId);
    } else {
      this.fundSelectedIdMap[fundId] = true;
      this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, fundId);
      this.listOffundIDs.push(fundId);
    }
    this.resetPageNoandSize();
    if (this.listOffundIDs.length == 0) {
      this.clearCompactFundSelection();
      return;
    }
    this.isAllFundsSelected = this.dropdownListFund && this.listOffundIDs.length === this.dropdownListFund.length;
    if (this.isAllFundsSelected) {
      this.selectedItemsFund = [this.buildAllFundsPlaceholder(this.listOffundIDs.length)];
    } else {
      this.selectedItemsFund = [this.buildFundCountPlaceholder(this.listOffundIDs.length)];
    }
    this.syncFundDropdownSelection(this.selectedItemsFund, this.isAllFundsSelected);
    this.GetContent();
  }

  private compactSelectedFundIfNeeded() {
    if (!this.selectedItemsFund || this.selectedItemsFund.length <= this.fundBadgeLimit
      || this.isPlaceholderFundSelection(this.selectedItemsFund)) {
      return;
    }
    this.listOffundIDs = this.getIdsFromItems(this.selectedItemsFund);
    this.fundSelectedIdMap = {};
    for (let i = 0; i < this.listOffundIDs.length; i++) {
      this.fundSelectedIdMap[this.listOffundIDs[i]] = true;
    }
    this.setSelectedFundDisplay(this.selectedItemsFund);
  }

  private setSelectedFundDisplay(selectedItems: any[]) {
    selectedItems = selectedItems || [];
    if (this.isAllFundsSelected && this.dropdownListFund && this.dropdownListFund.length > 0) {
      this.selectedItemsFund = [this.buildAllFundsPlaceholder(this.dropdownListFund.length)];
    } else if (selectedItems.length > this.fundBadgeLimit) {
      this.selectedItemsFund = [this.buildFundCountPlaceholder(selectedItems.length)];
    } else {
      this.selectedItemsFund = selectedItems;
    }
    this.syncFundDropdownSelection(this.selectedItemsFund, this.isAllFundsSelected);
  }

  private syncFundDropdownSelection(selectedItems: any[], selectAll?: boolean) {
    const dropdown: any = this.fundFilterDropdown;
    if (!dropdown) {
      return;
    }
    dropdown.selectedItems = selectedItems || [];
    dropdown.isSelectAll = !!selectAll || this.isAllFundsSelected;
    if (typeof dropdown.onChangeCallback === 'function') {
      dropdown.onChangeCallback(dropdown.selectedItems);
    }
    this.markFundSelectAllChecked();
  }

  private markFundSelectAllChecked() {
    const dropdown: any = this.fundFilterDropdown;
    if (!dropdown) {
      return;
    }
    dropdown.isSelectAll = this.isAllFundsSelected && !!(this.dropdownListFund && this.dropdownListFund.length > 0);
  }

  private buildAllFundsPlaceholder(count: number) {
    return { id: this.allFundsPlaceholderId, itemName: 'All Funds (' + count + ')', fundName: 'All Funds (' + count + ')' };
  }

  private buildFundCountPlaceholder(count: number) {
    return { id: this.manyFundsPlaceholderId, itemName: count + ' Funds', fundName: count + ' Funds' };
  }

  private isPlaceholderFundSelection(items: any[]): boolean {
    return !!(items && items.length == 1 && this.isPlaceholderFundItem(items[0]));
  }

  private isPlaceholderFundItem(item: any): boolean {
    return !!(item && (item.id === this.allFundsPlaceholderId || item.id === this.manyFundsPlaceholderId));
  }

  private appendSelectedFundItem(item: any): any[] {
    const selectedItems = this.selectedItemsFund ? this.selectedItemsFund.slice() : [];
    const fundId = item.id != null ? item.id : item.fundID;
    for (let i = 0; i < selectedItems.length; i++) {
      if (selectedItems[i] && selectedItems[i].id === fundId) {
        return selectedItems;
      }
    }
    selectedItems.push(item);
    return selectedItems;
  }

  private getIdsFromItems(items: any[]): any[] {
    if (!items || items.length == 0) {
      return [];
    }
    const ids = new Array(items.length);
    for (let i = 0; i < items.length; i++) {
      ids[i] = items[i].id != null ? items[i].id : items[i].fundID;
    }
    return ids;
  }

  private addIdsFromItems(existingIds: any[], items: any[]): any[] {
    if (!items || items.length == 0) {
      return existingIds || [];
    }
    const idSet = {};
    const result = existingIds ? existingIds.slice() : [];
    for (let i = 0; i < result.length; i++) {
      idSet[result[i]] = true;
    }
    for (let i = 0; i < items.length; i++) {
      const id = items[i].id != null ? items[i].id : items[i].fundID;
      if (!idSet[id]) {
        idSet[id] = true;
        result.push(id);
      }
    }
    return result;
  }

  private removeIdsFromItems(existingIds: any[], items: any[]): any[] {
    if (!existingIds || existingIds.length == 0) {
      return [];
    }
    if (!items || items.length == 0) {
      return existingIds;
    }
    const removeSet = {};
    for (let i = 0; i < items.length; i++) {
      const id = items[i].id != null ? items[i].id : items[i].fundID;
      removeSet[id] = true;
    }
    const result = [];
    for (let i = 0; i < existingIds.length; i++) {
      if (!removeSet[existingIds[i]]) {
        result.push(existingIds[i]);
      }
    }
    return result;
  }
}
